import { combineReducers } from 'redux';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

import commonReducer from './common';

const persistConfig = {
  key: 'root',
  version: 1,
  storage,
};

const rootReducer = combineReducers({
  common: commonReducer,
});

const persistedReducer = persistReducer(persistConfig, rootReducer);

export default persistedReducer;
